import { render, staticRenderFns } from "./indicator-customization-environment.vue?vue&type=template&id=3b5f045a&scoped=true&"
import script from "./indicator-customization-environment.vue?vue&type=script&lang=js&"
export * from "./indicator-customization-environment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f045a",
  null
  
)

export default component.exports